import { useNavigate } from "react-router-dom";
import { useHonorTitle, useHonorTier, TIERS } from "@/lib/honor";

export const HonorBadge = ({ userId, size = "sm", testId }) => {
  const title = useHonorTitle(userId);
  const tier = useHonorTier(userId);
  const navigate = useNavigate();
  if (!title) return null;
  const lg = size === "lg";
  const { icon: Icon, label } = TIERS[tier];
  const go = (e) => { e.preventDefault(); e.stopPropagation(); navigate("/ehrenwand"); };
  return (
    <span role="link" tabIndex={0} onClick={go} onKeyDown={(e) => e.key === "Enter" && go(e)} data-testid={testId || `honor-badge-${userId}`} data-tier={tier} title={`${title} (${label}) – zur Ehrenwand`}
      className={`tier-${tier} honor-chip inline-flex items-center gap-1 shrink-0 whitespace-nowrap align-middle rounded-full font-extrabold tracking-wider cursor-pointer hover:scale-105 transition-transform ${lg ? "text-xs px-2.5 py-1" : "text-[10px] px-1.5 py-px"}`}>
      <Icon className={lg ? "w-3.5 h-3.5" : "w-2.5 h-2.5"} strokeWidth={2.5} /> Ehrenmitglied
    </span>
  );
};
